import React from "react";
import "./Sacred_Pulse.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import Info_Card from "../../common/common_components/info_card/Info_Card";

const Sacred_Pulse = ({ all_spandan }) => {
  const data = [
    "A spiritual event or retreat focused on inner transformation.",
    "A meditative or cultural gathering that revives the sacred rhythms of life.",
    "The collective heartbeat of the community, reflecting harmony, seva (service), and spiritual discipline.",
    "Whether it's through bhajans, meditation, yoga, or seva, Spandan becomes the soul’s response to the Divine, a pulse that aligns each devotee with universal consciousness.",
  ];

  return (
    <section className="Sacred_Pulse">
      <div className="container">
        <div className="content_div">
          <Common_Title_2 subText={all_spandan?.name} />

          <p className="info_text">
            {all_spandan?.shortdescription}
          </p>

          <Info_Card data={all_spandan?.content} />

        </div>
      </div>
    </section>
  );
};

export default Sacred_Pulse;
